import { InputAdornment } from "@mui/material";
import { NumberInput, minValue, required } from "react-admin";
import { integerValidator } from "utils/validations";
import GridItem from "./GridItem";

const HoursInput = ({ source, label, md = 4, lg, isRequired = false }) => (
  <GridItem
    md={md}
    lg={lg}
  >
    <NumberInput
      source={source}
      label={label}
      fullWidth
      min={0}
      step={1}
      validate={[
        ...(isRequired ? [required("Полето е задължително.")] : []),
        minValue(0, "Минималната стойност е 0."),
        integerValidator,
      ]}
      InputProps={{ endAdornment: <InputAdornment position="end">ч.</InputAdornment> }}
      onWheel={e => e.target.blur()}
    />
  </GridItem>
);

export default HoursInput;
